module.exports = __webpack_public_path__ + "img/img10.bcf0574e.svg";